import isString from 'mout/lang/isString';
import isArray from 'mout/lang/isArray';

export default (field, activeCategories) => {
  let inCategory = false;
  if (activeCategories === undefined) return false;
  if (field.get('category') === undefined) inCategory = true;
  else if (
    field.get('category') !== undefined &&
    isString(field.get('category')) &&
    activeCategories.indexOf(field.get('category')) >= 0
  )
    inCategory = true;
  else if (field.get('category') !== undefined && field.get('category').map !== undefined) {
    // console.log('test', field.get('id'))
    const found = field.get('category').filter((c) => {
    return  (isArray(activeCategories)) ? activeCategories.indexOf(c) >= 0 : activeCategories === c
    });
    if (found.size > 0) inCategory = true;
  }
  // console.log(field.get('id'), inCategory, activeCategories, field.get('category') ? field.get('category').toJS() : false)
  return inCategory;
};



// WEBPACK FOOTER //
// ./src/helpers/isInCategory.js